import { Component, Input, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-datalist-input',
  templateUrl: './datalist-input.component.html',
  styleUrls: ['./datalist-input.component.scss']
})
export class DatalistInputComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() name: string;
  @Input() mandatory: boolean;
  @Input() helpTooltipText: string;
  @Input() possibleValues: string[];
  @Input() displayValuesMapper: Record<string, string>;
  @Input() placeholderText = 'Informe ou Selecione';
  @Input() autocomplete = 'off';
  @Input() hideNullOption = true;
  @Input() isDisabled: boolean;
  @Input() isLoading: boolean;
  @Input() error: any;
  @Input() hasError: boolean;
  public value: string;
  public idList: string;

  constructor(@Self() public controlDirective: NgControl) {
    controlDirective.valueAccessor = this;

  }

  ngOnInit(){
    this.idList = this.id + 's';
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onChange: any = () => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public onTouched: any = () => {};

  public writeValue(value: string) {
    this.value = value;
  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public handleInput() {
    this.onChange(this.value);
  }

  public getItemDisplayValue(item: string) {
    if (this.displayValuesMapper) {
      return this.displayValuesMapper[item];
    }
    return item;
  }
}
